// import { GridColDef } from "@mui/x-data-grid";
import { Box } from "@mui/material";
// import { GridActionsCellItem } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/RemoveCircleOutline"; // Or use Remove, Close, etc.

// Reusable checkbox renderer for editable booleans
// const BooleanEditCell = ({ value, api, field, id }) => {
//     const handleChange = (event) => {
//         api.setEditCellValue({ id, field, value: event.target.checked }, event);
//     };

//     return (
//         <Checkbox
//             checked={!!value}
//             onChange={handleChange}
//             color="primary"
//         />
//     );
// };

export const adminItemColumns = (changes, originalRows, handleRemove) => {
    const isEdited = (id, field, value) => {
        const original = originalRows.find((r) => r.id === id);
        return original && original[field] !== value;
    };

    const baseCol = (field, flex, headerName, editable = true, type = "string") => ({
        field,
        headerName,
        editable,
        type,
        flex: flex,
        align: 'center',
        headerAlign: 'center',
        cellClassName: (params) =>
            isEdited(params.id, field, params.value) ? 'edited-cell' : '',
    });

    return [
        {
            field: "id",
            headerName: "Item ID",
            editable: false,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
        },
        baseCol("name", 2, "Item Name"),
        baseCol("current_value_min", 1, "Min", true, "number"),
        baseCol("current_value_max", 1, "Max", true, "number"),
        {
            field: "is_stable",
            headerName: "Stable?",
            type: "boolean",
            editable: true,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params) =>
                isEdited(params.id, "is_stable", params.value) ? 'edited-cell' : '',
        },
        {
            field: "is_volatile",
            headerName: "Volatile?",
            type: "boolean",
            editable: true,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params) =>
                isEdited(params.id, "is_volatile", params.value) ? 'edited-cell' : '',
        },
        {
            field: "type",
            headerName: "Type",
            editable: true,
            type: "singleSelect",
            valueOptions: ["nonwearable", "wearable", "token", "neohome", "special"],
            flex: 1,
            align: "center",
            headerAlign: "center",
            cellClassName: (params) =>
                isEdited(params.id, "type", params.value) ? "edited-cell" : "",
        },
        baseCol("notes", 2, "Notes"),
        {
            field: "last_updated",
            headerName: "Last Updated",
            editable: false,
            width: 140,
            headerAlign: "center",
            align: "center",
            valueFormatter: (params) => {
                return params ? params.substring(0, 10) : "";
            }
        },
        {
            field: "remove",
            headerName: "",
            sortable: false,
            filterable: false,
            align: "center",
            headerAlign: "center",
            width: 60,
            renderCell: (params) => (
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    width="100%"
                    height="100%"
                >
                    <DeleteIcon
                        onClick={() => handleRemove(params.id)}
                        sx={{ cursor: "pointer", color: "#e53935" }}
                        titleAccess="Remove"
                    />
                </Box>
            ),
        }

    ];
};
